import React from 'react';
import ReactPDF, { Text } from '@react-pdf/renderer';

interface SpanProps extends Partial<ReactPDF.Text> {
  placeholder?: string | undefined;
  style?: {};
  children?: React.ReactNode;
  missingValue?: any;
  canBeMissingValue?: boolean;
  key?: any;
  wrap?: boolean;
}

export const Span = ({ placeholder, style, children, canBeMissingValue = false, wrap, missingValue }: SpanProps) => {
  return (
    <Text style={style} wrap={wrap}>
      {canBeMissingValue && !missingValue ? placeholder || '' : children || placeholder || ''}
    </Text>
  );
};
